import LazyLoad from 'vanilla-lazyload';

import BlogPostManager from '@d-shared/blog/blog-post-manager';
import Typeform from '@d-shared/blog/typeform';
import WidgetManager from '@d-shared/blog/widget-manager';

const BLOG_PATHNAME_PREFIX = '/discovery/blog';

export default {
  initialize: async (Vue) => {
    // Wait for Vue to process the DOM
    await Vue.nextTick();

    new LazyLoad({
      elements_selector: 'img[data-src],img[data-srcset],source[data-srcset]',
    });

    (new BlogPostManager).install();
    (new WidgetManager).install();
    (new Typeform).install();
  },

  install: function(Vue) {
    if (!document.location.pathname.startsWith(BLOG_PATHNAME_PREFIX)) {
      return;
    }

    this.initialize(Vue);
  },
};
